import { APIClient, APIOrderClient } from 'service/apicataleg/useApiUser';
import { APIAuthClient as http } from 'service/apicataleg/api/APIHttpClient';
import { AddressDTO, ClientDTO, MarcaDTO } from 'service/apicataleg/types/ApiCatalegTypes';

const ClientService: APIClient = {
  async getMarques(): Promise<Array<MarcaDTO>> {
    try {
      const { data } = await http.get<Array<MarcaDTO>>('/client/marques');
      return data;
    } catch (error) {
      return [];
    }
  },
  async getClientDetails(): Promise<ClientDTO | null> {
    try {
      const { data } = await http.get(`/client/whoiam`);
      return data;
    } catch (error) {
      return null;
    }
  },

  async getClientAddresses(): Promise<Array<AddressDTO>> {
    try {
      const { data } = await http.get(`/client/address`);
      return data;
    } catch (error) {
      return [];
    }
  },

  async addClientAddress(address: AddressDTO): Promise<AddressDTO | null> {
    try {
      const { data } = await http.post(`/client/address`, address);
      return data;
    } catch (error) {
      return null;
    }
  },

  async updateClientAddress(address: AddressDTO): Promise<boolean> {
    try {
      await http.put(`/client/address/${address.codi}`, address);
      return true;
    } catch (error) {
      return false;
    }
  },
};

export default ClientService;
